import React from 'react';
import { connect } from 'react-redux';
import { createActions } from '../../../../store';
import SliderListItem from '../../../../../../list-items/SliderListItem';
import { previewHistoryBatch } from '../../../../store/extensions';

const LyricsShadowBlurListItem = (props) => {
    const { shadowSettingsBlur, updateLyricsStyle, maxDropShadowBlur } = props;

    const onShadowBlurChange = (value) => {
        previewHistoryBatch.start();

        updateLyricsStyle({
            shadowSettings: { blur: value }
        });
    };

    return (
        <SliderListItem
            title='Blur'
            value={shadowSettingsBlur}
            displayMultiplier={2}
            min={0}
            max={100}
            step={1}
            onValueChange={onShadowBlurChange}
        />
    );
};

const mapStateToProps = (state) => {
    const { shadowSettings } = state.createPreview.present.videoSettings.lyrics.style;
    const shadowSettingsBlur = shadowSettings ? shadowSettings.blur : 0;
    const { maxDropShadowBlur } = state.create.maxValues;

    return {
        shadowSettingsBlur,
        maxDropShadowBlur
    };
}

const mapDispatchToProps = (dispatch) => {
    const updateLyricsStyle = (properties) => dispatch(createActions.updateLyricsStyle(properties));
    return { updateLyricsStyle }
}

export default connect(mapStateToProps, mapDispatchToProps)(LyricsShadowBlurListItem);
